import { Form, Formik } from "formik";
import * as Yup from "yup";
import FormController from "../components/formFields/FormController";
import FormLayout from "../../src/layouts/Form/FormLayout";
import { Box, Button, Typography } from "@mui/material";
import { isSubmitEnabled } from "../lib/helperFuncs";
import { useLocation, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import AuthContext, { useAuthContext } from "../context/AuthContext";
import axios from "axios";

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const from = location.state?.from?.pathname || "/dashboard";
  const { login, setLoading } = useAuthContext();
  const initialValues = {
    username: "",
    password: "",
  };

  const validationSchema = Yup.object({
    username: Yup.string().required("Παρακαλούμε συπληρώστε το πεδίο"),
    password: Yup.string().required("Παρακαλούμε συπληρώστε το πεδίο"),
  });

  const info_array = [
    {
      control: "input",
      type: "text",
      label: "Όνομα Χρήστη",
      name: "username",
      required: true,
    },
    {
      control: "input",
      type: "password",
      name: "password",
      label: "Κωδικός",
      required: true,
    },
  ];
  const SubmitValues = async (values) => {
    setLoading(true);
    login(values);
  };

  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        sx={{
          paddingY: { xs: 5, md: 15 },
        }}
      >
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          validateOnBlur={true}
          onSubmit={SubmitValues}
        >
          {(formik) => {
            return (
              <>
                <Form>
                  <FormLayout>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        flexWrap: "wrap",
                        mx: "auto",
                        gap: 3,
                        width: "25%",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: { xs: "column", md: "row" },
                          gap: 3,
                          alignItems: "center",
                          mx: "auto",
                          width: "80%",
                        }}
                      >
                        <Box>
                          <img
                            src={process.env.PUBLIC_URL + "/favicon.png"}
                            alt="favicon"
                            style={{
                              width: "4em",
                            }}
                          />
                        </Box>

                        <Box>
                          <Typography
                            component="h1"
                            variant="h5"
                            sx={{
                              fontWeight: "bold",
                              textAlign: { xs: "center", md: "left" },
                              fontSize: "1.3rem",
                            }}
                          >
                            Είσοδος στο Σύστημα
                          </Typography>
                        </Box>
                      </Box>

                      {info_array.map((el, key) => {
                        return (
                          <FormController
                            key={key}
                            control={el.control}
                            label={el.label}
                            type={el.type}
                            name={el.name}
                            formik={formik}
                            disabled={el.disabled}
                            options={el.options}
                            required={el.required}
                          />
                        );
                      })}
                    </Box>
                    <Button
                      variant="contained"
                      sx={{ display: "flex", mx: "auto" }}
                      type="submit"
                      onClick={() => SubmitValues(formik.values)}
                      disabled={isSubmitEnabled(formik)}
                    >
                      Σύνδεση
                    </Button>
                  </FormLayout>
                </Form>
              </>
            );
          }}
        </Formik>
      </Box>
    </>
  );
};
export default Login;
